import * as React from "react";

const SvgDataIcon = props => <svg width={14} height={14} viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M-6.11959e-07 0L0 14L14 14L14 -6.11959e-07L-6.11959e-07 0ZM4.2 12.6L1.4 12.6L1.4 1.4L4.2 1.4L4.2 12.6ZM8.4 12.6L5.6 12.6L5.6 1.4L8.4 1.4L8.4 12.6ZM12.6 12.6L9.8 12.6L9.8 1.4L12.6 1.4L12.6 12.6Z" /></svg>;

export default SvgDataIcon;